import { request } from '@/shared/api/request'

export const saveAllowStaffCivil = (data) => {
	return request({
		url: 'staff/saveAllowStaffCivil',
		method: 'POST',
		params: data,
	})
}
